import React from 'react';
import { Modal } from 'react-bootstrap';
import { ShortlistDetailsSection } from './shortlistDetailsSection';
import './shortlistDetails.css';
export const ShortlistDetailsPopup = ({
    open,
    onClose,
    shortlistDetails,
    candidateId,
    refreshShortlistDetails,
}) => {
    return (
        <Modal show={open} onHide={onClose} size="lg" centered className="sl-details-modal">
            <Modal.Header closeButton>
                <Modal.Title>Shortlist Status</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {Array.isArray(shortlistDetails) && shortlistDetails.length > 0 ? (
                    <ShortlistDetailsSection
                        shortlistDetails={shortlistDetails}
                        candidateId={candidateId}
                        refreshShortlistDetails={refreshShortlistDetails}
                    />
                ) : (
                    <p>No status found.</p>
                )}
            </Modal.Body>
        </Modal>
    );
};